import { call, takeLatest, all, put } from "redux-saga/effects";
import { AuthService } from "../../services/user/AuthService";
import {
  TActionGetUserWithUserId,
  TActionLoginWithEmailPayload,
} from "./login.types";
import {
  actionGetUserById,
  actionGetUserByIdFailed,
  actionGetUserByIdSuccess,
  actionSubmitLogin,
  actionSubmitLoginFailed,
  actionSubmitLoginSuccess,
} from "./login.reducer";
import { auth } from "../../config/firebase";
import { AdminServices } from "../../services/admin/AdminServices";

function* submitEmailLogin({ payload }: TActionLoginWithEmailPayload): any {
  try {
    yield call(AuthService.submitEmailLogin, payload);
    const currentUser = auth.currentUser;
    if (currentUser) {
      const userId = currentUser.uid;
      yield put(actionSubmitLoginSuccess());
      yield put(actionGetUserById({ userId }));
    }
  } catch (error) {
    yield put(actionSubmitLoginFailed());
  }
}

// payload = { userId?: string; email?: string }

function* getUserInformation({ payload }: TActionGetUserWithUserId): any {
  try {
    let data;

    if (payload?.userId) {
      data = yield call(AdminServices.getUserById, payload.userId);
    } else if (payload?.email) {
      data = yield call(AdminServices.getUserByEmail, payload.email);
    } else {
      throw new Error("Either userId or email must be provided.");
    }

    yield put(actionGetUserByIdSuccess(data?.response));
  } catch (error) {
    console.log("Error => ", error);
    yield put(actionGetUserByIdFailed());
  }
}

export function* loginWatcher() {
  yield all([
    takeLatest(actionSubmitLogin.type, submitEmailLogin),
    takeLatest(actionGetUserById.type, getUserInformation),
  ]);
}